import { OfflineOrderCheckout } from 'api/admin/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialMultipleFeatureStateFactory<EntityType<OfflineOrderCheckout>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const setPayOfflineAdminOrderReducer = createReducer<State, Actions>(initialState, {
  [actions.setPayOfflineAdminOrder.request.type]: actionsHandlers.handleMultipleFeatureRequest,
  [actions.setPayOfflineAdminOrder.success.type]: actionsHandlers.handleMultipleFeatureSuccess,
  [actions.setPayOfflineAdminOrder.failure.type]: actionsHandlers.handleMultipleFeatureFailure,
  [actions.setPayOfflineAdminOrder.reset.type]: actionsHandlers.handleMultipleFeatureReset,
});

export default setPayOfflineAdminOrderReducer;
